import React, { useEffect, useState } from "react";
import { Trophy, ExternalLink } from "lucide-react";
import api from "@/lib/api";

// Compact "Top 10 AI nations" strip below the globe. Data comes from the same
// cited Global AI Index as the globe; clicking a nation opens its country panel.
export default function GlobeLeaderboard({ onSelect }) {
  const [rows, setRows] = useState([]);
  const [source, setSource] = useState("");

  useEffect(() => {
    api.get("/countries")
      .then((r) => {
        const cs = [...(r.data.countries || [])].sort((a, b) => a.rank - b.rank).slice(0, 10);
        setRows(cs);
        setSource(r.data.source || "");
      })
      .catch(() => {});
  }, []);

  if (!rows.length) return null;

  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 pt-8" data-testid="globe-leaderboard">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-4">
        <h2 className="font-display font-bold text-lg md:text-xl flex items-center gap-2">
          <Trophy className="w-5 h-5 text-[#FBBF24]" /> Top 10 AI nations
        </h2>
        <span className="text-xs text-[#64748B] font-mono-tech">Ranked by the {source}</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2.5">
        {rows.map((c) => (
          <button key={c.code} onClick={() => onSelect({ code: c.code, name: c.name })}
            data-testid={`leaderboard-${c.code}`}
            className="group flex items-center gap-2.5 rounded-xl border border-white/10 bg-[#0e1424] px-3 py-2.5 text-left hover:border-[#00F0FF]/50 hover:bg-[#111c2e] transition">
            <span className={`font-display font-bold text-sm w-6 shrink-0 ${c.rank <= 3 ? "text-[#FBBF24]" : "text-[#00F0FF]"}`}>#{c.rank}</span>
            <span className="text-xl leading-none">{c.flag}</span>
            <span className="text-sm text-white truncate flex-1">{c.name}</span>
            <ExternalLink className="w-3.5 h-3.5 text-[#64748B] opacity-0 group-hover:opacity-100 transition" />
          </button>
        ))}
      </div>
    </section>
  );
}
